import { useEffect, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useAlert } from 'react-alert'

import {
  TestesFetchModel,
  TestesModel,
  TypeToAvaliacaoModel
} from '../../../../domain/models'
import {
  fetchListAllTestes,
  filterListAllTestes
} from '../../../../main/usecases'

import { goToUrl, formatDate } from '../../../utils'
import { useModalBox, useOnChangeDetect } from '../../../contexts'
import { Button, Table, EmptyData, InputFilter } from '../../../components'
import DeleteTesteModal from './delete-testes'
import FilterCustomTesteModal from './filter-custom-testes'

import {
  PlusSvg,
  IconEditSvg,
  IconTrashSvg
} from '../../../assets/icons/svgComponents'

import * as S from './styles'

type FilterValuesProps = {
  typeToService: string
  teste: string
}

const Tests = () => {
  const [testes, setTestes] = useState<TestesFetchModel>()
  const [filterValues, setFilterValues] = useState<FilterValuesProps>()
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const history = useHistory()
  const { modalBox } = useModalBox()
  const alert = useAlert()
  const { refresh } = useOnChangeDetect()
  console.log(testes)
  const handleRemoveFilterTestes = async () => {
    try {
      setFilterValues({ typeToService: '', teste: '' })

      const filterData = await filterListAllTestes({
        typeToService: '',
        teste: '',
        page: page
      }).load()

      setTestes(filterData)
    } catch (error) {
      console.error(error)
      alert.show('Erro ao remover filtro', {
        type: 'error',
        timeout: 4000
      })
    }
  }

  const handleFilterTestes = async () => {
    try {
      const filterData = await filterListAllTestes({
        typeToService: filterValues?.typeToService || '',
        teste: filterValues?.teste || '',
        page: page
      }).load()

      setTestes(filterData)
    } catch (error) {
      console.error(error)
      alert.show('Erro ao filtrar', {
        type: 'error',
        timeout: 4000
      })
    }
  }

  const handleClickNewClientRegister = () => {
    modalBox(<FilterCustomTesteModal />, 'Personalize um teste', '38%')
  }

  const columns = useMemo(
    () => [
      {
        Header: 'Nome do teste',
        accessor: 'nameToTeste'
      },
      {
        Header: 'Tipo da avaliação',
        accessor: 'nameToService'
      },
      {
        Header: 'Data de atualização',
        accessor: 'dataUltimaModificao'
      },
      {
        Header: '',
        accessor: 'actions'
      }
    ],
    []
  )

  const data = useMemo(() => {
    const handleRedirectToRegistrationData = async (
      teste: TestesModel,
      typeToService: TypeToAvaliacaoModel
    ) => {
      try {
        setLoading(true)
        console.log({
          cdTeste: teste && teste.cdTeste,
          cdTypeToService: typeToService && typeToService.cdTipoAvaliacao,
          testeTitle: teste && teste.nome,
          serviceTitle: typeToService && typeToService.tipoAvaliacao
        })
        goToUrl(history, `/teste`, {
          cdTeste: teste && teste.cdTeste,
          cdTypeToService: typeToService && typeToService.cdTipoAvaliacao,
          testeTitle: teste && teste.nome,
          serviceTitle: typeToService && typeToService.tipoAvaliacao
        })
      } catch (error) {
        console.error(error)
        alert.show('Erro ao entrar em um teste personalizado', {
          type: 'error',
          timeout: 4000
        })
      } finally {
        setLoading(false)
      }
    }

    const handleOpenDeleteModal = (
      cdTypeToService: number,
      cdTeste: number
    ) => {
      modalBox(
        <DeleteTesteModal
          cdTypeToService={cdTypeToService}
          cdTeste={cdTeste}
        />,
        'Deletar um teste personalizado',
        '32%'
      )
    }

    return testes?.content?.map((item: any) => {
      console.log(item)
      return {
        nameToTeste: item?.teste.nome,
        nameToService: item?.tipoAvaliacao?.tipoAvaliacao,
        dataUltimaModificao: formatDate(item?.dataUltimaModificacao),
        actions: (
          <div className="table-icons">
            <button
              disabled={loading}
              onClick={() =>
                handleRedirectToRegistrationData(item.teste, item.tipoAvaliacao)
              }
              title="Editar"
            >
              <IconEditSvg />
            </button>
            <div
              onClick={() =>
                handleOpenDeleteModal(
                  item.tipoAvaliacao.cdTipoAvaliacao,
                  item.teste.cdTeste
                )
              }
            >
              <IconTrashSvg />
            </div>
          </div>
        )
      }
    })
  }, [testes?.content, modalBox, loading, alert, history])

  useEffect(() => {
    ;(async () => {
      try {
        const data = await fetchListAllTestes({ page: page }).load()
        setTestes(data)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [page, refresh])

  return (
    <S.Wrapper>
      <S.Title>Meus testes</S.Title>
      <S.CardContainer>
        <S.ActionsContainer>
          <Button
            initialIcon={<PlusSvg />}
            onClick={handleClickNewClientRegister}
          >
            Personalize um teste
          </Button>
          <InputFilter
            name="filter"
            type="text"
            optionsToRadio={[
              { name: 'teste', label: 'Teste' },
              { name: 'typeToService', label: 'Tipo de avaliação' }
            ]}
            placeholder="Pesquisar"
            onFilter={handleFilterTestes}
            onRemove={handleRemoveFilterTestes}
            setFilterValues={setFilterValues}
            filterValues={filterValues}
          />
        </S.ActionsContainer>
        <S.TableContainer>
          {testes && testes?.content?.length ? (
            <Table
              onClick={() => ({})}
              columns={columns}
              dataTable={data}
              handlePageClick={(currentPage: any) =>
                setPage(currentPage.selected + 1)
              }
              pageCount={testes?.totalPages}
            />
          ) : testes?.empty && testes?.content?.length ? (
            <EmptyData>Não há nenhum teste para esse filtro</EmptyData>
          ) : (
            <EmptyData>Personalize um modelo de um teste</EmptyData>
          )}
        </S.TableContainer>
      </S.CardContainer>
    </S.Wrapper>
  )
}
export default Tests
